import React from 'react';
import PageTitle from '../../layouts/PageTitle';

const TopZip = () => {
    return (
        <div className='zipCode'>

            <PageTitle
                title="Reports"
                subtitle="Top Zip"
            />


            <div className='date_select'>
                <select className='border-0' name="week" id="week" style={{ width: '60px' }}>
                    <option value="" selected>Today</option>
                    <option value="">Yesterday</option>
                    <option value="">This week</option>
                    <option value="">Last week</option>
                    <option value="">Custom</option>
                </select>
            </div>
            <div className='card-header ziptop-portion mt-2' style={{ padding: '0 px' }}>
                <div className="row w-100 ml-1">
                    <div className="col-md-6 col-lg-6">
                        <h3>Zip code performance </h3>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <i className="mdi mdi-download"></i>
                        <i className="mdi mdi-send ml-3"></i>
                    </div>
                </div>
            </div>
            <div className='card-header ziptop-portion' style={{ padding: '0 0' }}>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <span>Postcode</span>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <span>Order amount/Revenue</span>
                    </div>
                </div>
            </div>
            <div className='card-header ziptop-portion'>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <b>62876</b>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li className='fs-4 count text-right'>171</li>
                            <li className='mt-1'>SGD 425.50</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='card-header ziptop-portion'>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <b>659496</b>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li className='fs-4 count text-right'>48</li>
                            <li> SGD 355.50</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='card-header ziptop-portion'>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <b>600123</b>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li className='fs-4 count text-right'>45</li>
                            <li> SGD 132.70</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='card-header ziptop-portion'>
                <div className="row w-100 align-items-center ms-1">
                    <div className="col-md-6 col-lg-6">
                        <b>611234</b>
                    </div>
                    <div className="col-md-6 col-lg-6 d-flex justify-content-end">
                        <ul>
                            <li className='fs-4 count text-right'>1</li>
                            <li> SGD 356.70</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <span className=''>Disclaimer. Please note that the reports present raw and unconditioned order data. Revenues include onlyfood values(excluding discounts, delivery fees, etc).Final settlements can be from the invoice</span>
            </div>
        </div>
    );
};

export default TopZip;